export const ms = {
  "name": "Malaysia",
  "flagCode": "my",
  "locale": "ms-MY",
  "project": {
    "name": "Driver Signup"
  },
  "key": "ms",
  "validations": {
    "PLEASE_SELECT_CITY": "Please select city.",
    "PLEASE_SELECT_SERVICE": "Please select service.",
    "PLEASE_SELECT_DRIVER_TYPE": "Please select driver type.",
    "PLEASE_INPUT_FIRSTNAME": "Please enter your first name.",
    "PLEASE_INPUT_LASTNAME": "Please enter your last name.",
    "PLEASE_INPUT_EMAIL": "Please enter your email.",
    "INVALID_EMAIL": "Sila nyatakan e-mel yang betul",
    "PLEASE_INPUT_MOBILE_PHONE": "Please enter your phone number.",
    "INVALID_PHONE_NUMBER": "Please specify a valid phone number.",
    "PHONE_NUNBER_EXITS": "Nombor telepon pernah didaftar",
    "USERNAME_EXITS": "This username already exists on our system.",
    "ERROR_INPUT_VALID_USERNAME": "Username may only contain lower letters & numbers and must be between 3 and 20 characters long",
    "FIELD_IS_REQUIRED": "Ruang wajib diisi",
    "REFERRAL_CODE_INVALID": "Referral code is invalid.",
    "EMAIL_EXITS": "This email already exists. Please enter another one.",
    "INVALID_USERNAME": "Please specify a valid username.",
    "FIELD_IS_REQUIRED_BETWEEN_3_TO_20": "Username must be between 3 and 20 characters.",
    "PHONE_NUNBER_EXITS_IN_GROUP": ""
  },
  "errors": {
    "3034": "This phone has been existing on the system. Please input another one.",
    "4001": "The License Plate is exits",
    "NETWORK_ERROR": "Error: Network Error"
  },
  "general": {
    "CONTINUE": "Continue",
    "STEP_COMPLETE": "{0}/{1} Complete",
    "STEP_HEADER": "Step {0}",
    "BACK": "Back",
    "NEXT": "Next",
    "SUBMIT": "Submit",
    "Clear_Selected_Items": "Clear selected items",
    "no_results": "No results",
    "add_new_item": "Add New"
  },
  "home": {
    "BECOME": "Become a %{name} Driver.",
    "HEADING": "Enter your basic information to get started",
    "APPLY_NOW": "Daftar Disini",
    "INDIVIDUAL_CAR_GOJO": "Transport/Taxi - I own vehicle",
    "INDIVIDUAL_CAR": "Kenderaan Persendirian/Teksi",
    "COMPANY_CAR": "Kenderaan Perdagangan",
    "DELIVERY_INDIVIDUAL_CAR": "Delivery - I own vehicle",
    "DELIVERY_COMPANY_CAR": "Delivery - Company vehicle",
    "PLACEHOVER_SELECT_PRE_CITY": "Bandar",
    "PLACEHOVER_SELECT_REGISTRATION_TYPE": "Pilih jenis pemandu",
    "USERNAME": "Username",
    "FIRST_NAME": "Nama Pertama",
    "LAST_NAME": "Nama Akhir",
    "EMAIL": "Alamat Emel (optional)",
    "PHONE_NUMBER": "Nombor Telepon",
    "REFERRAL_CODE": "Referral code (optional)",
    "I_AGREE_TO": "Dengan pendaftaran ini, saya telah membaca dan setuju dengan",
    "TERMS_OF_USE": "terma dan syarat",
    "AND": "serta",
    "PRIVACY_POLICY": "polisi pelindungan peribadi",
    "I_AGREE_TO_AFTER": ".",
    "Company": "Supplier",
  },
  "finish": {
    "FINISH_1": "Terima kasih kerana mendaftar dengan %{name}!",
    "FINISH_3": "Daftar masuk sekarang!",
    "FINISH_USE_PASSWORD_1": "Almost there!",
    "FINISH_USE_PASSWORD_2": "To activate your account and receive jobs, please follow these steps:",
    "FINISH_USE_PASSWORD_3": "1. Login with your registered phone number",
    "FINISH_USE_PASSWORD_4": "2. Password: <span style='font-weight: bold'>12345678</span>",
    "FINISH_USE_PASSWORD_5": "3. Complete your application",
    "OK": "Daftar Masuk",
    "downloadApp": "Muat turun aplikasi <span style='color: %{color}' >%{name}</span> sekarang dan daftar masuk menggunakan nombor telefon anda."
  },
  "datePlaceHolder": "MM/DD/YYYY"
};